export enum UserType {
  MASTER = "Master",
  MANAGER = "Manager"
}
